import React, { useEffect, useState } from 'react';
import { useLoaderData } from 'react-router-dom';
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from 'recharts';
import axios from 'axios';

const Statistics = () => {
    const loadTotal = useLoaderData().data;
    console.log(loadTotal);


    // const { total, id, name, questions } = loadTotal;

    const totals = loadTotal.map((loadTotal) => {
        return loadTotal.total;
    })
    const names = loadTotal.map((loadTotal) => {
        return loadTotal.name;
    })


    return (
        <div className='mr-auto ml-auto'>
            <div><h1 className='font-bold text-2xl'> This Chart Represents Total Number of Questions on Each Topic</h1></div>


            <div className=' mt-10 mr-10'>
                <LineChart width={700}
                    height={700}
                    data={loadTotal}
                    margin={{
                        top: 5,
                        right: 50,
                        left: 50,
                        bottom: 5,
                    }}

                >
                    <Line type="monotone" dataKey='total' stroke="#8884d8" />
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey='name' />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                </LineChart>
            </div>
        </div>
    );
};

export default Statistics;